/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ success: NonNullable<unknown>, "duplicates, select, 0 {": NonNullable<unknown>, "⚠ {duplicates": NonNullable<unknown>, "failed, select, 0 {": NonNullable<unknown>, "✗ {failed": NonNullable<unknown> }} Preset_Manager_Import_Results_MessageInputs */



/**
* | output |
* | --- |
* | "Import complete: ✓ {success} preset(s) imported successfully {duplicates, select, 0 {} other {⚠ {duplicates} duplicate(s) renamed }}{failed, select, 0 {} oth..." |
*
* @param {Preset_Manager_Import_Results_MessageInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const preset_manager_import_results_message = /** @type {((inputs: Preset_Manager_Import_Results_MessageInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Preset_Manager_Import_Results_MessageInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Importation terminee :
✓ ${i?.success} preset(s) importe(s) avec succes
${i?.["duplicates, select, 0 {"]} other ${i?.["⚠ {duplicates"]} doublon(s) renomme(s)
}}${i?.["failed, select, 0 {"]} other ${i?.["✗ {failed"]} preset(s) non importe(s)}}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Import abgeschlossen:
✓ ${i?.success} Voreinstellung(en) erfolgreich importiert
${i?.["duplicates, select, 0 {"]} other ${i?.["⚠ {duplicates"]} duplicate(s) renamed
}}${i?.["failed, select, 0 {"]} other ${i?.["✗ {failed"]} preset(s) failed to import}}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Importazione completata:
✓ ${i?.success} preset importati correttamente
${i?.["duplicates, select, 0 {"]} other ${i?.["⚠ {duplicates"]} duplicate(s) renamed
}}${i?.["failed, select, 0 {"]} other ${i?.["✗ {failed"]} preset(s) failed to import}}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Импорт завершен:
✓ ${i?.success} пресеты успешно импортированы
${i?.["duplicates, select, 0 {"]} other ${i?.["⚠ {duplicates"]} duplicate(s) renamed
}}${i?.["failed, select, 0 {"]} other ${i?.["✗ {failed"]} preset(s) failed to import}}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Importación completada:
✓ ${i?.success} ajustes preestablecidos importados correctamente
${i?.["duplicates, select, 0 {"]} other ${i?.["⚠ {duplicates"]} duplicate(s) renamed
}}${i?.["failed, select, 0 {"]} other ${i?.["✗ {failed"]} preset(s) failed to import}}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`导入完成：
✓ ${i?.success} 预设已成功导入
${i?.["duplicates, select, 0 {"]} other ${i?.["⚠ {duplicates"]} duplicate(s) renamed
}}${i?.["failed, select, 0 {"]} other ${i?.["✗ {failed"]} preset(s) failed to import}}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`インポートが完了しました:
✓ ${i?.success} プリセットが正常にインポートされました
${i?.["duplicates, select, 0 {"]} other ${i?.["⚠ {duplicates"]} duplicate(s) renamed
}}${i?.["failed, select, 0 {"]} other ${i?.["✗ {failed"]} preset(s) failed to import}}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`आयात पूर्ण:
✓ ${i?.success} प्रीसेट सफलतापूर्वक आयात किए गए
${i?.["duplicates, select, 0 {"]} other ${i?.["⚠ {duplicates"]} duplicate(s) renamed
}}${i?.["failed, select, 0 {"]} other ${i?.["✗ {failed"]} preset(s) failed to import}}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Importação concluída:
✓ ${i?.success} predefinições importadas com sucesso
${i?.["duplicates, select, 0 {"]} other ${i?.["⚠ {duplicates"]} duplicate(s) renamed
}}${i?.["failed, select, 0 {"]} other ${i?.["✗ {failed"]} preset(s) failed to import}}`)
	return /** @type {LocalizedString} */ (`Import complete:
✓ ${i?.success} preset(s) imported successfully
${i?.["duplicates, select, 0 {"]} other ${i?.["⚠ {duplicates"]} duplicate(s) renamed
}}${i?.["failed, select, 0 {"]} other ${i?.["✗ {failed"]} preset(s) failed to import}}`)
});